import { Modal } from '@fasstech/middle-design-system';
import PropTypes from 'prop-types';

const ResumeModal = ({
  isDisplayed = false,
  setDisplayModal,
  resumeModalTitle,
  resumeModalText,
  resumeModalButton
}) => {
  return (
    <Modal
      isDisplayed={isDisplayed}
      button1Label={resumeModalButton}
      button2Label={'Annuler'}
      onClose={() => setDisplayModal(false)}
      onClick1={() => setDisplayModal(false)}
      onClick2={() => setDisplayModal(false)}
      icon="circleClock"
      className="w-[80vw] max-w-2xl">
      <>
        <div className="text-2xl font-semibold mb-4">{resumeModalTitle}</div>

        <div dangerouslySetInnerHTML={{ __html: resumeModalText }}></div>
      </>
    </Modal>
  );
};

ResumeModal.propTypes = {
  isDisplayed: PropTypes.bool,
  setDisplayModal: PropTypes.func
};

export default ResumeModal;
